import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

//	///////////////////////
//	MARK: IMPORTS
const Index = lazy(() => import('./Index'))

//	///////////////////////
//	MARK: EXPORTS
export const AnalyticsAircraftRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--analytics--aircraft']}>
    <Route index element={<Index />} />
  </SubRouter>
))
